import { render, staticRenderFns } from "./ConfigurableItemFormDialog.vue?vue&type=template&id=a88cce0a&"
import script from "./ConfigurableItemFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfigurableItemFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports